import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';

import {HeaderDiv, HeaderTitleDiv, HeaderIconImg} from '../../pages';
import {uploadRecUri, uploadDlUri, uploadMiscUri} from '../../config/uri';
import {setUser} from '../../reducers/userReducer';
import {saveDocument} from '../../services/upload';
import * as modal from '../../reducers/modalReducer';
import { pushWithQueryParams } from '../../services/uri';

const $ = require('jquery');

const styles = {
  headerIcon: {width: '30px', height: '30px'}
};

const myAccountIcon = `${process.env.PUBLIC_URL}/assets/img/icons/preferences-disabled.png`;

class UpdateDocsPage extends Component {

  handleIdClick = () => {
    if (this.props.user.isID) {
      this.props.go(uploadDlUri);
    } else {
      ReactDOM.findDOMNode(this.refs.idFileInput).click();
    }
  }
  handleRecClick = () => {
    if (this.props.user.isRec) {
      this.props.go(uploadRecUri);
    } else {
      ReactDOM.findDOMNode(this.refs.recFileInput).click();
    }
  }
  handleMiscClick = () => {
    // TODO add misc click
    if (this.props.user.isMisc) {
      this.props.go(uploadMiscUri);
    } else {
      ReactDOM.findDOMNode(this.refs.miscFileInput).click();
    }
  }
  handleIdFile = (e) => {
    const file = $('#id-file')[0].files[0];
    this.props.saveDocument(file, 'dl').then(() => {
      this.props.setUser({
        isID: true
      });
      this.props.openUploadSuccess();
      $('#id-file')[0].value = null;
    }).catch((err) => {
      this.props.openUploadError();
      $('#id-file')[0].value = null;
    });
  }
  handleRecFile = (e) => {
    const file = $('#rec-file')[0].files[0];
    this.props.saveDocument(file, 'rec').then(() => {
      this.props.setUser({
        isRec: true
      });
      this.props.openUploadSuccess();
      $('#rec-file')[0].value = null;
    }).catch((err) => {
      this.props.openUploadError();
      $('#rec-file')[0].value = null;
    });
  }
  handleMiscFile = (e) => {
    const file = $('#misc-file')[0].files[0];
    this.props.saveDocument(file, 'misc').then(() => {
      this.props.setUser({
        isMisc: true
      });
      this.props.openUploadSuccess();
      $('#misc-file')[0].value = null;
    }).catch((err) => {
      this.props.openUploadError();
      $('#misc-file')[0].value = null;
    });
  }

  render() {
    return (
      <div>
        <HeaderDiv>
          <HeaderIconImg style={styles.headerIcon} src={myAccountIcon} />
          <HeaderTitleDiv>Upload or update documents</HeaderTitleDiv>
        </HeaderDiv>
        <div className="account-options">
          <div onClick={this.handleRecClick} className="account-item"><p>Update Rec</p></div>
          <div onClick={this.handleIdClick} className="account-item"><p>Update ID</p></div>
          <div onClick={this.handleMiscClick} className="account-item"><p>Update Misc</p></div>
          <div style={{display: 'none'}}>
            <input ref="idFileInput" type="file" name="id-file" id="id-file" onChange={this.handleIdFile} accept="image/gif, image/jpeg, image/png"/>
            <input ref="recFileInput" type="file" name="rec-file" id="rec-file" onChange={this.handleRecFile} accept="image/gif, image/jpeg, image/png"/>
            <input ref="miscFileInput" type="file" name="misc-file" id="misc-file" onChange={this.handleMiscFile} accept="image/gif, image/jpeg, image/png"/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  go: (uri) => dispatch(pushWithQueryParams(uri)),
  saveDocument: (file, type) => saveDocument(file, type),
  openUploadSuccess: () => dispatch(modal.openModal({
    modalType: 'UPLOAD_INFO',
    modalProps: {}
  })),
  openUploadError: () => dispatch(modal.openModal({
    modalType: 'UPLOAD_INFO',
    modalProps: {error: true}
  })),
  setUser: (user) => dispatch(setUser(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateDocsPage);



// WEBPACK FOOTER //
// ./src/components/UpdateDocsPage/UpdateDocsPage.js